import { defineTokens } from "@chakra-ui/react";

export const fonts = defineTokens.fonts({
  heading: {
    value: '"Ostrich", Arial, Helvetica, sans-serif',
  },
  body: {
    value: '"Ostrich", Arial, Helvetica, sans-serif',
  },
  mono: {
    value:
      'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
  },
});
